module.exports = __webpack_public_path__ + "resources/img/img_prodiscovery5_m.382cce68bd5a38e2fae18f44fea02221.png";